import { render, staticRenderFns } from "./ListItem.vue?vue&type=template&id=4b7f1e8c&scoped=true"
import script from "./ListItem.vue?vue&type=script&lang=js"
export * from "./ListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7f1e8c",
  null
  
)

export default component.exports